export default __webpack_public_path__ + "static/img-m-mesquita-2-29b39d076ae50cf2960ca3bf95cf7505.png";